export const REFERRER_QUERY_PARAM = 'referrer';
